module.exports = __webpack_public_path__ + "img/child_icon.25e67805.svg";